import request from '@/utils/request'

// 获取网站菜单列表
export const getMenu = () => {
  return request({
    url: '/official/menu',
    method: 'get'
  })
}
// 获取网站配置
export const getConfig = () => {
  return request({
    url: '/official/config',
    method: 'get'
  })
}
// 获取文档(产品/视频)列表
export const documentList = (params) => {
  return request({
    url: '/official/documentList',
    method: 'get',
    params:params
  })
}
// 获取分类下直接的带详情的文档列表
export const documentContentList = (params) => {
  return request({
    url: '/official/getDocumentContentList',
    method: 'get',
    params:params
  })
}
// 获取文档详情
export const documentContent = (documentId) => {
  return request({
    url: '/official/documentContent',
    method: 'get',
    params:{
      documentId:documentId //文档id
    }
  })
}
// 获取产品分类
export const getCategory = (params) => {
  return request({
    url: '/official/category',
    method: 'get',
    params
  })
}
// 添加留言
export const addMessageBoard = (data) => {
  return request({
    url: '/official/addMessageBoard',
    method: 'post',
    data
  })
}
// 获取推荐产品列表
export const getRecommendDocumentList = (params) => {
  return request({
    url: '/official/getRecommendDocumentList',
    method: 'get',
    params
  })
}
//新增访问数据
export const browse = (data) => {
  return request({
    url: '/visits/browse',
    method: 'post',
    data
  })
}
// 获取banner列表
export const bannerList = (params) => {
  return request({
    url: '/official/list',
    method: 'get',
    params
  })
}
// 获取栏目文档详情
export const getColumnDocumentInfo = (params) => {
  return request({
    url: '/column/getColumnDocumentInfo',
    method: 'get',
    params
  })
}
// 分页获取文档列表
export const documentListByPage = (params) => {
  return request({
    url: '/official/documentListByPage',
    method: 'get',
    params
  })
}
